import React, {useMemo, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {AgGridReact} from "ag-grid-react";
import moment from "moment";
import {FaEye} from "react-icons/fa";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import formBuilderService from "../../../../services/web/form-builder-service.js";
import aggridUtils from "../../../../utils/aggrid-utils.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const SubmissionsModal = ({open, setOpen, templateId, selected}) => {
    const gridRef = useRef(undefined);

    const {data, isFetching} = useQuery({
        queryFn: () => formBuilderService.submissionList(templateId),
        queryKey: ["form-submissions", templateId],
        enabled: open && !!templateId
    });

    const rows = useMemo(() => {
        const pdfIds = selected?.pdfIds ?? [];

        return (data ?? []).filter(({pdf_id}) => pdfIds.includes(pdf_id));
    }, [data, selected]);

    const [columnDefs] = useState([
        {
            headerName: "Preenchido por",
            field: "namewar",
            flex: 1,
            valueFormatter: ({data}) => data.namewar || data.name,
            comparator: aggridUtils.nullLastComparator
        },
        {
            headerName: "Data/hora",
            field: "created_at",
            flex: 1,
            sort: "desc",
            valueFormatter: ({value}) => moment(value).format("DD/MM/YYYY HH:mm")
        },
        {
            headerName: "",
            field: "",
            cellRenderer: ({node}) => (
                <div className="text-center w-full h-full content-center">
                    <Button
                        title={"Visualizar formulário"}
                        onClick={() => window.open(`${API_KEEPER}/ged/attach/print/pdf/${node.data.pdf_id}`)}
                    >
                        <FaEye/>
                    </Button>
                </div>
            ),
            width: 80
        }
    ]);

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const theme = useMemo(() => aggridUtils.generalTheme(), []);

    return (
        <Modal open={open} setOpen={setOpen} title={"Formulários preenchidos"} className={"w-10/12"}>
            <Modal.Body>
                <div style={{height: "60vh"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={40}
                        rowData={rows}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={false}
                        suppressCellFocus={true}
                        loading={isFetching}
                        pagination
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={theme}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SubmissionsModal;
